<template>
  <div class="app-container">
    <el-form ref="form" :model="form">
      <el-form-item prop="address">
        <div id="map-container" style="width: 100%; height: 43vh" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable */
import loadBMap from "@/utils/loadBMap.js";
export default {
  props: ["bMapRes"],
  data() {
    return {
      BMap: null,
      form: {
        address: "", // 详细地址
        addrPoint: {
          // 详细地址经纬度
          lng: 0,
          lat: 0,
        },
      },
      map: "", // 地图实例
      mk: "", // Marker实例
      list: [],
      point: null,
      // lat: 23.148614488154006,
      // lng: 113.33667068937726,
      lat: 23.142278,
      lng: 113.335445,
    };
  },
  async mounted() {
    await loadBMap("oW2UEhdth2tRbEE4FUpF9E5YVDCIPYih"); // 加载引入BMap
    this.initMap();
  },
  methods: {
    // 初始化地图
    initMap() {
      // console.logthis.bMapRes);
      var that = this;
      // 1、挂载地图
      this.map = new BMap.Map("map-container", {
        enableMapClick: false,
      });
      var point = new BMap.Point(this.lng, this.lat);

      this.map.centerAndZoom(point, 19);
      this.map.enableScrollWheelZoom(true);
      // 3、设置图像标注并绑定拖拽标注结束后事件
      this.mk = new BMap.Marker(point, {
        enableDragging: true,
      });
      this.map.addOverlay(this.mk);
      this.mk.addEventListener("dragend", function (e) {
        that.getAddrByPoint(e.point);
      });
      // 4、添加（右上角）平移缩放控件
      this.map.addControl(
        new BMap.NavigationControl({
          anchor: BMAP_ANCHOR_TOP_RIGHT,
          type: BMAP_NAVIGATION_CONTROL_LARGE,
        })
      );

      // 6、浏览器定位
      // this.geolocation();

      // 7、绑定点击地图任意点事件
      this.map.addEventListener("click", function (e) {
        that.getAddrByPoint(e.point);
      });
    },
    // 浏览器定位函数
    geolocation() {
      var that = this;
      var geolocation = new BMap.Geolocation();
      console.log(geolocation);
      geolocation.getCurrentPosition(
        function (res) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            that.getAddrByPoint(res.point);
          } else {
            that.$alert(this.getStatus(), "提示", {
              confirmButtonText: "确定",
              type: "warning",
              center: true,
              callback: (action) => {},
            });
            if (that.point) {
              that.getAddrByPoint(that.point);
            } else {
              if (res.point) {
                res.point.lat = 39.915095185635316;
                res.point.lng = 116.40397079994426;
                that.getAddrByPoint(res.point);
              } else {
                let form = {
                  lat: 39.915095185635316,
                  lng: 116.40397079994426,
                };
                that.getAddrByPoint(form);
              }
            }
          }
        },
        {
          enableHighAccuracy: true,
        }
      );
    },
    // 2、逆地址解析函数
    getAddrByPoint(point) {
      var that = this;
      var geco = new BMap.Geocoder();
      geco.getLocation(point, function (res) {
        that.$emit("getAddrByPoint", res);
        that.form = res;
        that.mk.setPosition(point);
        that.map.panTo(point);
      });
    },
  },
};
</script>

<style>
.el-icon-location-information {
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/baiduMap/baidu.vue